<template>
    <div id="simpleSoccerTable" :class="{ 'odds-hidden': !isOddsSwitch }" v-if="(sortedEvents && (sortedEvents.length > 0 || Object.keys(sortedEvents).length > 0)) || (leagueList && (leagueList.length > 0 || Object.keys(leagueList).length > 0))">
      <DynamicScroller
        :items="items"
        page-mode
        :min-item-size="142"
        :buffer="500"
        class="scroller"
        v-if="items.length"
      >
        <template v-slot="{ item, index, active }">
          <DynamicScrollerItem
            :item="item"
            :active="active"
            :size-dependencies="[item.message]"
            :data-index="index"
          >
            <div data-v-5bf51e32="" :index="index" class="s-w-item user" :class="!hideLegHeader[item.key] ? 'llgggAll llggg'+item.obj:''" v-if="!isLoading && !item.isResult && ((!checkLeague(item.obj, item.sptid) && !item.subdis) || item.subdis)">
              <div data-v-5bf51e32="" class="s-w-i-inner">
                <div data-v-379cdb5e="" data-v-5bf51e32="" class="data_mid">
                  <div data-v-065fe993="" data-v-379cdb5e="" class="match-container" :class="{'first is_league_tail':item.key==0, 'is_division_league':item.subdis}" data-v-5bf51e32="" v-if="!loadingScreen">
                    <div data-v-065fe993="" class="match-inner-container" :id="'match-inner-container'+item.eveid">
                      <div class="league-header" :class="{'collapsed':checkLeague(item.obj,item.sptid)}" v-if="item.subdis" @click="showHide(item.obj,item.sptid)" :id="'llge'+item.obj">
                          <div class="league-title-row">
                              <div class="league-icon" v-if="(account.showCtrLogo && item.ctrlogo) || (account.showLogo && item.lglogo)">
                                <img :src="account.showCtrLogo && item.ctrlogo ? item.ctrlogo : item.lglogo">
                              </div>
                              <span class="league-name" :title="item.lgecapt">{{ item.lgecapt }}</span>
                          </div>
                          <div class="league-subtext-row full-row">
                              <div class="sub-left" :style="item.sptid == 2? 'width: 215px !important;':''">
                                  <span class="match-time">{{ getDate(item.dt) }} {{ getTime(item.dt) }}</span>
                                  <span class="match-minute"></span>
                              </div>
                              <div class="sub-center">{{ sportAllBetLang['ALL_BET.LBL_SCO'] }}</div> 
                              <div class="sub-right">
                                  <div class="odds-title-row" :class="{'bk': item.sptid == 2}">
                                      <span>1</span>
                                      <template v-if="item.sptid == 1"><span>x</span></template>
                                      <span>2</span>
                                  </div>
                              </div>
                          </div>
                          <svg class="league-arrow" viewBox="0 0 24 24" fill="none" stroke-width="2">
                              <polyline points="6 9 12 15 18 9" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"></polyline>
                          </svg>
                      </div>
                      <!-- <template v-for="(subMatch, subMatchKey) in (item.sub + 1)" v-if="subMatch <= 1"> -->
                        <div class="league-content" :class="'llge'+item.obj" v-if="!checkLeague(item.obj,item.sptid)">
                          <div class="match-row" :class="{ 'first': item.subdis }" @click="getAllBet(item)">
                            <div class="match-main-info">
                                <div class="favorite-toggle" @click.stop="favourite(item)" :class="{ 'active': item.isFavourite }"></div>
                                <div class="team-info left">
                                    <div class="team-avatar">
                                        <div class="team-icon" v-if="account.showLogo && item.talogo !=''">
                                          <img :src="item.talogo">
                                        </div>
                                    </div>
                                    <span class="team-name" :title="item.tacapt">{{ item.tacapt }}</span>
                                    <!-- <span class="score-punish" v-if="item.rbinfo && item.rbinfo.rca > 0">{{ item.rbinfo.rca }}</span> -->
                                </div>
                                <div class="match-score-box notranslate" :style="item.sptid == 2? 'width: 60px !important;':''">
                                  <!-- <template v-if="item.rbinfo">{{ item.rbinfo.scoa }} - {{ item.rbinfo.scob }}</template> -->
                                  <template v-if="item.rb && item.rb==='0'">VS</template>
                                  <template v-else>
                                    <template v-if="item.score && item.score.FT">
                                      <template v-if="item.score.FT.includes('Suspend')">
                                        <div class="suspend">{{ sportAllBetLang['ALL_BET.SUSPEND'] }}<br>{{ item.score.FT.split("Suspend")[1] }}</div>
                                      </template>
                                      <template v-else>
                                        <div class="">{{ item.score.FT }}</div>
                                      </template>
                                    </template>
                                    <template v-else-if="item.score && item.score.HT">
                                      <template v-if="item.score.HT.includes('Suspend')">
                                        <div class="suspend">{{ sportAllBetLang['ALL_BET.SUSPEND'] }}<br>{{ item.score.HT.split("Suspend")[1] }}</div>
                                      </template>
                                      <template v-else>
                                        <div class="">{{ item.score.HT }}</div>
                                      </template>
                                    </template>
                                    <template v-else>0 - 0</template>
                                  </template>
                                </div>
                                <div class="team-info right">
                                    <!-- <span class="score-punish" v-if="item.rbinfo && item.rbinfo.rcb > 0">{{ item.rbinfo.rcb }}</span> -->
                                    <span class="team-name" :title="item.tbcapt" style="text-align: right;">{{ item.tbcapt }}</span>
                                    <div class="team-avatar">
                                        <div class="team-icon" v-if="account.showLogo && item.tblogo !=''">
                                          <img :src="item.tblogo">
                                        </div>
                                    </div>
                                </div>
                                <div class="video-icon" :class="{ 'disable': item.rb != 1 }" title="live" v-if="item.rb != -1 && item.ch != undefined && item.ch != 0" @click.stop="getAllBet(item,1)"></div>
                            </div>
                            <div class="odds-title-row">
                              <span>1</span>
                              <template v-if="item.sptid == 1"><span>x</span></template>
                              <span>2</span>
                            </div>
                            <odds1x2 :event="item"></odds1x2>
                            <!-- <simpleSoccer1x2 :event="item" :plytyp="playtypeSelection_1()" :bettyp="getBettype(item.sptid, item.rbstatus)"></simpleSoccer1x2> -->
                            <!-- <div class="odds-row">
                                <span class="odds-box">1.50</span>
                                <span class="odds-box">3.40</span>
                                <span class="odds-box">2.20</span>
                            </div> -->
                          </div>
                        </div>
                      <!-- </template> -->
                    </div>
                  </div>
                </div>
              </div>
              <!-- <div data-v-c9bcc182="" class="loading-more-container" slot="footer" style="margin-bottom: 12px;" v-if="item.key==(items.length-1)">
                <div data-v-c9bcc182="" style="color: rgb(170, 174, 184); font-size: 0.12rem;">{{ sportTableLang['SPORT_TABLE.END'] }}</div>
              </div> -->
            </div>
            <!-- <div class="outter-wrap skeleton-wrap ssc"  v-else-if="isLoading" :style="item.key==0?'padding-top:'+marginPX+'rem':''">
              <div data-v-3a8f5f1a="" class="list">
                <div data-v-3a8f5f1a="" class="version_biaozhun" style="margin-top:0px">
                  <div data-v-3a8f5f1a="" class="item">
                    <div data-v-3a8f5f1a="" class="title">
                      <div data-v-eed1ea58="" data-v-3a8f5f1a="" class="skeleton radius_50" style="width: 0.2rem; height: 0.2rem;"></div>
                      <div data-v-eed1ea58="" data-v-3a8f5f1a="" class="skeleton radius_6" style="width: 1.4rem; height: 0.1rem;"></div>
                    </div>
                    <div data-v-3a8f5f1a="" class="info" style="width:100%">
                      <template v-if="!account.previewFlag">
                        <div data-v-eed1ea58="" data-v-3a8f5f1a="" class="skeleton radius_6" style="width: 50%; height: 0.1rem;"></div>
                        <div data-v-eed1ea58="" data-v-3a8f5f1a="" class="skeleton radius_6" style="width: 50%; height: 0.1rem;"></div>
                      </template>
                      <template v-else>
                        <div data-v-3a8f5f1a="">
                          <div data-v-eed1ea58="" data-v-3a8f5f1a="" class="skeleton radius_2" style="width: 1.45rem; height: 0.20rem;"></div>
                        </div>
                        <div data-v-3a8f5f1a="">
                          <div data-v-eed1ea58="" data-v-3a8f5f1a="" class="skeleton radius_2" style="width: 0.55rem; height: 0.20rem; margin: 3px;"></div>
                        </div>
                        <div data-v-3a8f5f1a="">
                          <div data-v-eed1ea58="" data-v-3a8f5f1a="" class="skeleton radius_2" style="width: 1.45rem; height: 0.20rem;"></div>
                        </div>
                      </template>
                    </div>
                    <div data-v-3a8f5f1a="" class="wrap"  :style="account.previewFlag ? 'height:0.2rem !important':''">
                      <div data-v-3a8f5f1a="" class="content" :style="item.sptid!=1 ? 'width: 100%':''">
                        <div data-v-3a8f5f1a="" class="content-wrap" :style="item.sptid!=1 ? 'width: inherit':''">
                          <template v-if="item.sptid==1">
                            <div data-v-3a8f5f1a="">
                              <div data-v-eed1ea58="" data-v-3a8f5f1a="" class="skeleton radius_2" style="width: 1.45rem; height: 0.20rem;"></div>
                            </div>
                            <div data-v-3a8f5f1a="">
                              <div data-v-eed1ea58="" data-v-3a8f5f1a="" class="skeleton radius_2" style="width: 0.55rem; height: 0.20rem;"></div>
                            </div>
                            <div data-v-3a8f5f1a="">
                              <div data-v-eed1ea58="" data-v-3a8f5f1a="" class="skeleton radius_2" style="width: 1.45rem; height: 0.20rem;"></div>
                            </div>
                          </template>
                        </div>
                        <div data-v-3a8f5f1a="" class="content-wrap" :style="item.sptid!=1 ? 'width: inherit':''" >
                          <template v-if="item.sptid==1 && !account.previewFlag">
                            <div data-v-3a8f5f1a="">
                              <div data-v-eed1ea58="" data-v-3a8f5f1a="" class="skeleton radius_2" style="width: 0.57rem; height: 0.15rem;"></div>
                            </div>
                            <div data-v-3a8f5f1a="">
                              <div data-v-eed1ea58="" data-v-3a8f5f1a="" class="skeleton radius_2" style="width: 0.57rem; height: 0.15rem;"></div>
                            </div>
                            <div data-v-3a8f5f1a="">
                              <div data-v-eed1ea58="" data-v-3a8f5f1a="" class="skeleton radius_2" style="width: 0.57rem; height: 0.15rem;"></div>
                            </div>
                            <div data-v-3a8f5f1a="">
                              <div data-v-eed1ea58="" data-v-3a8f5f1a="" class="skeleton radius_2" style="width: 0.57rem; height: 0.15rem;"></div>
                            </div>
                            <div data-v-3a8f5f1a="">
                              <div data-v-eed1ea58="" data-v-3a8f5f1a="" class="skeleton radius_2" style="width: 0.57rem; height: 0.15rem;"></div>
                            </div>
                            <div data-v-3a8f5f1a="">
                              <div data-v-eed1ea58="" data-v-3a8f5f1a="" class="skeleton radius_2" style="width: 0.57rem; height: 0.15rem;"></div>
                            </div>
                          </template>
                        </div>
                        <div data-v-3a8f5f1a="" class="content-wrap" :style="item.sptid!=1 ? 'width: inherit':''" style="margin-top:5px">
                          <template v-if="item.sptid==1 && !account.previewFlag">
                            <div data-v-3a8f5f1a="">
                              <div data-v-eed1ea58="" data-v-3a8f5f1a="" class="skeleton radius_2" style="width: 0.57rem; height: 0.15rem;"></div>
                            </div>
                            <div data-v-3a8f5f1a="">
                              <div data-v-eed1ea58="" data-v-3a8f5f1a="" class="skeleton radius_2" style="width: 0.57rem; height: 0.15rem;"></div>
                            </div>
                            <div data-v-3a8f5f1a="">
                              <div data-v-eed1ea58="" data-v-3a8f5f1a="" class="skeleton radius_2" style="width: 0.57rem; height: 0.15rem;"></div>
                            </div>
                            <div data-v-3a8f5f1a="">
                              <div data-v-eed1ea58="" data-v-3a8f5f1a="" class="skeleton radius_2" style="width: 0.57rem; height: 0.15rem;"></div>
                            </div>
                            <div data-v-3a8f5f1a="">
                              <div data-v-eed1ea58="" data-v-3a8f5f1a="" class="skeleton radius_2" style="width: 0.57rem; height: 0.15rem;"></div>
                            </div>
                            <div data-v-3a8f5f1a="">
                              <div data-v-eed1ea58="" data-v-3a8f5f1a="" class="skeleton radius_2" style="width: 0.57rem; height: 0.15rem;"></div>
                            </div>
                          </template>
                        </div>
                        <div data-v-3a8f5f1a="" class="content-wrap" :style="item.sptid!=1 ? 'width: inherit':''" style="margin-top:5px">
                          <template v-if="item.sptid==1 && !account.previewFlag">
                            <div data-v-3a8f5f1a="">
                              <div data-v-eed1ea58="" data-v-3a8f5f1a="" class="skeleton radius_2" style="width: 0.57rem; height: 0.15rem;"></div>
                            </div>
                            <div data-v-3a8f5f1a="">
                              <div data-v-eed1ea58="" data-v-3a8f5f1a="" class="skeleton radius_2" style="width: 0.57rem; height: 0.15rem;"></div>
                            </div>
                            <div data-v-3a8f5f1a="">
                              <div data-v-eed1ea58="" data-v-3a8f5f1a="" class="skeleton radius_2" style="width: 0.57rem; height: 0.15rem;"></div>
                            </div>
                            <div data-v-3a8f5f1a="">
                              <div data-v-eed1ea58="" data-v-3a8f5f1a="" class="skeleton radius_2" style="width: 0.57rem; height: 0.15rem;"></div>
                            </div>
                            <div data-v-3a8f5f1a="">
                              <div data-v-eed1ea58="" data-v-3a8f5f1a="" class="skeleton radius_2" style="width: 0.57rem; height: 0.15rem;"></div>
                            </div>
                            <div data-v-3a8f5f1a="">
                              <div data-v-eed1ea58="" data-v-3a8f5f1a="" class="skeleton radius_2" style="width: 0.57rem; height: 0.15rem;"></div>
                            </div>
                          </template>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div data-v-3a8f5f1a="" class="item">
                    <div data-v-3a8f5f1a="" class="title">
                      <div data-v-eed1ea58="" data-v-3a8f5f1a="" class="skeleton radius_50" style="width: 0.2rem; height: 0.2rem;"></div>
                      <div data-v-eed1ea58="" data-v-3a8f5f1a="" class="skeleton radius_6" style="width: 1.4rem; height: 0.1rem;"></div>
                    </div>
                    <div data-v-3a8f5f1a="" class="info" style="width:100%">
                      <template v-if="!account.previewFlag">
                        <div data-v-eed1ea58="" data-v-3a8f5f1a="" class="skeleton radius_6" style="width: 50%; height: 0.1rem;"></div>
                        <div data-v-eed1ea58="" data-v-3a8f5f1a="" class="skeleton radius_6" style="width: 50%; height: 0.1rem;"></div>
                      </template>
                      <template v-else>
                        <div data-v-3a8f5f1a="">
                          <div data-v-eed1ea58="" data-v-3a8f5f1a="" class="skeleton radius_2" style="width: 1.45rem; height: 0.20rem;"></div>
                        </div>
                        <div data-v-3a8f5f1a="">
                          <div data-v-eed1ea58="" data-v-3a8f5f1a="" class="skeleton radius_2" style="width: 0.55rem; height: 0.20rem; margin: 3px;"></div>
                        </div>
                        <div data-v-3a8f5f1a="">
                          <div data-v-eed1ea58="" data-v-3a8f5f1a="" class="skeleton radius_2" style="width: 1.45rem; height: 0.20rem;"></div>
                        </div>
                      </template>
                    </div>
                    <div data-v-3a8f5f1a="" class="wrap"  :style="account.previewFlag ? 'height:0.2rem !important':''">
                      <div data-v-3a8f5f1a="" class="content" :style="item.sptid!=1 ? 'width:100%':''">
                        <div data-v-3a8f5f1a="" class="content-wrap" :style="item.sptid!=1 ? 'width:inherit':''">
                          <template v-if="item.sptid==1">
                            <div data-v-3a8f5f1a="">
                              <div data-v-eed1ea58="" data-v-3a8f5f1a="" class="skeleton radius_2" style="width: 1.45rem; height: 0.20rem;"></div>
                            </div>
                            <div data-v-3a8f5f1a="">
                              <div data-v-eed1ea58="" data-v-3a8f5f1a="" class="skeleton radius_2" style="width: 0.55rem; height: 0.20rem;"></div>
                            </div>
                            <div data-v-3a8f5f1a="">
                              <div data-v-eed1ea58="" data-v-3a8f5f1a="" class="skeleton radius_2" style="width: 1.45rem; height: 0.20rem;"></div>
                            </div>
                          </template>
                        </div>
                        <div data-v-3a8f5f1a="" class="content-wrap" :style="item.sptid!=1 ? 'width: inherit':''" >
                          <template v-if="item.sptid==1 && !account.previewFlag">
                            <div data-v-3a8f5f1a="">
                              <div data-v-eed1ea58="" data-v-3a8f5f1a="" class="skeleton radius_2" style="width: 0.57rem; height: 0.15rem;"></div>
                            </div>
                            <div data-v-3a8f5f1a="">
                              <div data-v-eed1ea58="" data-v-3a8f5f1a="" class="skeleton radius_2" style="width: 0.57rem; height: 0.15rem;"></div>
                            </div>
                            <div data-v-3a8f5f1a="">
                              <div data-v-eed1ea58="" data-v-3a8f5f1a="" class="skeleton radius_2" style="width: 0.57rem; height: 0.15rem;"></div>
                            </div>
                            <div data-v-3a8f5f1a="">
                              <div data-v-eed1ea58="" data-v-3a8f5f1a="" class="skeleton radius_2" style="width: 0.57rem; height: 0.15rem;"></div>
                            </div>
                            <div data-v-3a8f5f1a="">
                              <div data-v-eed1ea58="" data-v-3a8f5f1a="" class="skeleton radius_2" style="width: 0.57rem; height: 0.15rem;"></div>
                            </div>
                            <div data-v-3a8f5f1a="">
                              <div data-v-eed1ea58="" data-v-3a8f5f1a="" class="skeleton radius_2" style="width: 0.57rem; height: 0.15rem;"></div>
                            </div>
                          </template>
                        </div>
                        <div data-v-3a8f5f1a="" class="content-wrap" :style="item.sptid!=1 ? 'width: inherit':''" style="margin-top:5px">
                          <template v-if="item.sptid==1 && !account.previewFlag">
                            <div data-v-3a8f5f1a="">
                              <div data-v-eed1ea58="" data-v-3a8f5f1a="" class="skeleton radius_2" style="width: 0.57rem; height: 0.15rem;"></div>
                            </div>
                            <div data-v-3a8f5f1a="">
                              <div data-v-eed1ea58="" data-v-3a8f5f1a="" class="skeleton radius_2" style="width: 0.57rem; height: 0.15rem;"></div>
                            </div>
                            <div data-v-3a8f5f1a="">
                              <div data-v-eed1ea58="" data-v-3a8f5f1a="" class="skeleton radius_2" style="width: 0.57rem; height: 0.15rem;"></div>
                            </div>
                            <div data-v-3a8f5f1a="">
                              <div data-v-eed1ea58="" data-v-3a8f5f1a="" class="skeleton radius_2" style="width: 0.57rem; height: 0.15rem;"></div>
                            </div>
                            <div data-v-3a8f5f1a="">
                              <div data-v-eed1ea58="" data-v-3a8f5f1a="" class="skeleton radius_2" style="width: 0.57rem; height: 0.15rem;"></div>
                            </div>
                            <div data-v-3a8f5f1a="">
                              <div data-v-eed1ea58="" data-v-3a8f5f1a="" class="skeleton radius_2" style="width: 0.57rem; height: 0.15rem;"></div>
                            </div>
                          </template>
                        </div>
                        <div data-v-3a8f5f1a="" class="content-wrap" :style="item.sptid!=1 ? 'width: inherit':''" style="margin-top:5px">
                          <template v-if="item.sptid==1 && !account.previewFlag">
                            <div data-v-3a8f5f1a="">
                              <div data-v-eed1ea58="" data-v-3a8f5f1a="" class="skeleton radius_2" style="width: 0.57rem; height: 0.15rem;"></div>
                            </div>
                            <div data-v-3a8f5f1a="">
                              <div data-v-eed1ea58="" data-v-3a8f5f1a="" class="skeleton radius_2" style="width: 0.57rem; height: 0.15rem;"></div>
                            </div>
                            <div data-v-3a8f5f1a="">
                              <div data-v-eed1ea58="" data-v-3a8f5f1a="" class="skeleton radius_2" style="width: 0.57rem; height: 0.15rem;"></div>
                            </div>
                            <div data-v-3a8f5f1a="">
                              <div data-v-eed1ea58="" data-v-3a8f5f1a="" class="skeleton radius_2" style="width: 0.57rem; height: 0.15rem;"></div>
                            </div>
                            <div data-v-3a8f5f1a="">
                              <div data-v-eed1ea58="" data-v-3a8f5f1a="" class="skeleton radius_2" style="width: 0.57rem; height: 0.15rem;"></div>
                            </div>
                            <div data-v-3a8f5f1a="">
                              <div data-v-eed1ea58="" data-v-3a8f5f1a="" class="skeleton radius_2" style="width: 0.57rem; height: 0.15rem;"></div>
                            </div>
                          </template>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div data-v-3a8f5f1a="" class="item">
                    <div data-v-3a8f5f1a="" class="title">
                      <div data-v-eed1ea58="" data-v-3a8f5f1a="" class="skeleton radius_50" style="width: 0.2rem; height: 0.2rem;"></div>
                      <div data-v-eed1ea58="" data-v-3a8f5f1a="" class="skeleton radius_6" style="width: 1.4rem; height: 0.1rem;"></div>
                    </div>
                    <div data-v-3a8f5f1a="" class="info" style="width:100%">
                      <template v-if="!account.previewFlag">
                        <div data-v-eed1ea58="" data-v-3a8f5f1a="" class="skeleton radius_6" style="width: 50%; height: 0.1rem;"></div>
                        <div data-v-eed1ea58="" data-v-3a8f5f1a="" class="skeleton radius_6" style="width: 50%; height: 0.1rem;"></div>
                      </template>
                      <template v-else>
                        <div data-v-3a8f5f1a="">
                          <div data-v-eed1ea58="" data-v-3a8f5f1a="" class="skeleton radius_2" style="width: 1.45rem; height: 0.20rem;"></div>
                        </div>
                        <div data-v-3a8f5f1a="">
                          <div data-v-eed1ea58="" data-v-3a8f5f1a="" class="skeleton radius_2" style="width: 0.55rem; height: 0.20rem; margin: 3px;"></div>
                        </div>
                        <div data-v-3a8f5f1a="">
                          <div data-v-eed1ea58="" data-v-3a8f5f1a="" class="skeleton radius_2" style="width: 1.45rem; height: 0.20rem;"></div>
                        </div>
                      </template>
                    </div>
                    <div data-v-3a8f5f1a="" class="wrap"  :style="account.previewFlag ? 'height:0.2rem !important':''">
                      <div data-v-3a8f5f1a="" class="content" :style="item.sptid!=1 ? 'width:100%':''">
                        <div data-v-3a8f5f1a="" class="content-wrap" :style="item.sptid!=1 ? 'width:inherit':''">
                          <template v-if="item.sptid==1">
                            <div data-v-3a8f5f1a="">
                              <div data-v-eed1ea58="" data-v-3a8f5f1a="" class="skeleton radius_2" style="width: 1.45rem; height: 0.20rem;"></div>
                            </div>
                            <div data-v-3a8f5f1a="">
                              <div data-v-eed1ea58="" data-v-3a8f5f1a="" class="skeleton radius_2" style="width: 0.55rem; height: 0.20rem;"></div>
                            </div>
                            <div data-v-3a8f5f1a="">
                              <div data-v-eed1ea58="" data-v-3a8f5f1a="" class="skeleton radius_2" style="width: 1.45rem; height: 0.20rem;"></div>
                            </div>
                          </template>
                        </div>
                        <div data-v-3a8f5f1a="" class="content-wrap" :style="item.sptid!=1 ? 'width: inherit':''" >
                          <template v-if="item.sptid==1 && !account.previewFlag">
                            <div data-v-3a8f5f1a="">
                              <div data-v-eed1ea58="" data-v-3a8f5f1a="" class="skeleton radius_2" style="width: 0.57rem; height: 0.15rem;"></div>
                            </div>
                            <div data-v-3a8f5f1a="">
                              <div data-v-eed1ea58="" data-v-3a8f5f1a="" class="skeleton radius_2" style="width: 0.57rem; height: 0.15rem;"></div>
                            </div>
                            <div data-v-3a8f5f1a="">
                              <div data-v-eed1ea58="" data-v-3a8f5f1a="" class="skeleton radius_2" style="width: 0.57rem; height: 0.15rem;"></div>
                            </div>
                            <div data-v-3a8f5f1a="">
                              <div data-v-eed1ea58="" data-v-3a8f5f1a="" class="skeleton radius_2" style="width: 0.57rem; height: 0.15rem;"></div>
                            </div>
                            <div data-v-3a8f5f1a="">
                              <div data-v-eed1ea58="" data-v-3a8f5f1a="" class="skeleton radius_2" style="width: 0.57rem; height: 0.15rem;"></div>
                            </div>
                            <div data-v-3a8f5f1a="">
                              <div data-v-eed1ea58="" data-v-3a8f5f1a="" class="skeleton radius_2" style="width: 0.57rem; height: 0.15rem;"></div>
                            </div>
                          </template>
                        </div>
                        <div data-v-3a8f5f1a="" class="content-wrap" :style="item.sptid!=1 ? 'width: inherit':''" style="margin-top:5px">
                          <template v-if="item.sptid==1 && !account.previewFlag">
                            <div data-v-3a8f5f1a="">
                              <div data-v-eed1ea58="" data-v-3a8f5f1a="" class="skeleton radius_2" style="width: 0.57rem; height: 0.15rem;"></div>
                            </div>
                            <div data-v-3a8f5f1a="">
                              <div data-v-eed1ea58="" data-v-3a8f5f1a="" class="skeleton radius_2" style="width: 0.57rem; height: 0.15rem;"></div>
                            </div>
                            <div data-v-3a8f5f1a="">
                              <div data-v-eed1ea58="" data-v-3a8f5f1a="" class="skeleton radius_2" style="width: 0.57rem; height: 0.15rem;"></div>
                            </div>
                            <div data-v-3a8f5f1a="">
                              <div data-v-eed1ea58="" data-v-3a8f5f1a="" class="skeleton radius_2" style="width: 0.57rem; height: 0.15rem;"></div>
                            </div>
                            <div data-v-3a8f5f1a="">
                              <div data-v-eed1ea58="" data-v-3a8f5f1a="" class="skeleton radius_2" style="width: 0.57rem; height: 0.15rem;"></div>
                            </div>
                            <div data-v-3a8f5f1a="">
                              <div data-v-eed1ea58="" data-v-3a8f5f1a="" class="skeleton radius_2" style="width: 0.57rem; height: 0.15rem;"></div>
                            </div>
                          </template>
                        </div>
                        <div data-v-3a8f5f1a="" class="content-wrap" :style="item.sptid!=1 ? 'width: inherit':''" style="margin-top:5px">
                          <template v-if="item.sptid==1 && !account.previewFlag">
                            <div data-v-3a8f5f1a="">
                              <div data-v-eed1ea58="" data-v-3a8f5f1a="" class="skeleton radius_2" style="width: 0.57rem; height: 0.15rem;"></div>
                            </div>
                            <div data-v-3a8f5f1a="">
                              <div data-v-eed1ea58="" data-v-3a8f5f1a="" class="skeleton radius_2" style="width: 0.57rem; height: 0.15rem;"></div>
                            </div>
                            <div data-v-3a8f5f1a="">
                              <div data-v-eed1ea58="" data-v-3a8f5f1a="" class="skeleton radius_2" style="width: 0.57rem; height: 0.15rem;"></div>
                            </div>
                            <div data-v-3a8f5f1a="">
                              <div data-v-eed1ea58="" data-v-3a8f5f1a="" class="skeleton radius_2" style="width: 0.57rem; height: 0.15rem;"></div>
                            </div>
                            <div data-v-3a8f5f1a="">
                              <div data-v-eed1ea58="" data-v-3a8f5f1a="" class="skeleton radius_2" style="width: 0.57rem; height: 0.15rem;"></div>
                            </div>
                            <div data-v-3a8f5f1a="">
                              <div data-v-eed1ea58="" data-v-3a8f5f1a="" class="skeleton radius_2" style="width: 0.57rem; height: 0.15rem;"></div>
                            </div>
                          </template>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div> -->
          </DynamicScrollerItem>
        </template>
      </DynamicScroller>
    </div>
    <div data-v-549f1e7b="" data-v-379cdb5e="" class="no-data data-get-empty1" v-else> <!--  style="min-height: 444px; padding-top: 15em;" -->
        <template v-if="skinTheme==2">
          <div data-v-549f1e7b="" class="empty-favorite-bg" style="background-image: url('assets/images/score/noMatch2.png');"></div>
        </template>
        <template v-else>
          <div data-v-549f1e7b="" class="empty-favorite-bg" style="background-image: url('assets/images/score/noMatch.svg');"></div>
        </template>
        <p data-v-549f1e7b="" style="color: rgb(165, 169, 179);" v-if="!(gameBanner && isGameBannerSelected)">{{ arr_lang.sportTable['SPORT_TABLE.EMPTY'] }}</p>
        
    </div>
  </template>
  <script>
    import {
        mapGetters
      } from 'vuex'
  
    import {updateHightlightOdds} from '@/js/common/common'
  
    import EventBus from '@/vue/events/event-bus'
    import moment from 'moment'
    import allBetMixin from '@/vue/mixins/allBet'
    import odd1x2Components from '../../components/odd1x2'
    import backToTop from '../core/backToTop'
  
    import scrollEnd from '../core/scrollEnd'
  
    import 'vue-virtual-scroller/dist/vue-virtual-scroller.css'
    import { DynamicScroller , DynamicScrollerItem, RecycleScroller } from 'vue-virtual-scroller'
  
    // import simpleSoccer1x2 from './oddsTable/simpleSoccer-1x2'
    import odds1x2 from './oddsTable/odds1x2'
  
    import sportFavourite from '@/vue/mixins/favourite'
  
    const pageSize = 20
    const LOAD_THRESHOLD_PX = 400
    export default {
      props: {
        isOddsSwitch: {
          type: Boolean,
          default: false
        }
      },
      mixins: [allBetMixin, sportFavourite],
      computed: {
        ...mapGetters([
          'arr_eventList',
          'sortedEvents',
          'leagueList',
          'int_marketToggle',
          'sportTableLang',
          'sportAllBetLang',
          'arr_selectedTemplate',
          'currentBettingSelectionTemplate',
          'sportBettypeList',
          'market',
          'arr_lang',
          'bettingSelection',
          'tvIconFlag',
          'arr_earlyParlayDateList',
          'selectedMatches',
          'isParlay',
          'int_selectedParlayDate',
          'selectedState',
          'editionStand', //only soccer support, others sport is 0
          'simDisp',
          'skinTheme',
          'favouriteEvents',
          'titleSport',
          'loadingScreen',
          'hideLegHeader',
          'sortedTodayRBEvents',
          'arr_sportCountMarket',
          'refreshScreen',
          'virtualDataList',
          'showEnd',
          'showNoScrollEnd',
          'isHideLeague',
          'showLegCapt',
          'swipe', //1: left, 2: right
          'isCollapseMatch',
          'timeZone',
          'isGameBannerSelected',
          'lableHeader',
          'plytyp',
        ]),
        computehdpBetType: function(){
          if(this.int_marketToggle == 3){
            return '8'
          }else{
            return '1'
          }
        },
        currentSport(){
          var sprtId = this.arr_selectedTemplate.sportId
          return this.sportBettypeList[sprtId]['sprtTitleLang']
        },
        computeouBetType: function(){
          if(this.int_marketToggle == 3){
            return '9'
          }else{
            return '2'
          }
        },
        isCollapseMatch: function () {
              return this.$store.getters.isCollapseMatch
          },
      },
      components: {
        backToTop,
        scrollEnd,
        DynamicScroller,
        DynamicScrollerItem,
        // simpleSoccer1x2,
        RecycleScroller,
        odds1x2,
      },
      data() {
        return {   
          cookies_lang: window._cookie,
          lang: window.lang,
          heightPX:window.innerHeight-155,
          
          teamA: 'oddsa',
          teamB: 'oddsb',
          teamHome: 'h',
          teamAway: 'a',
          teamDraw: 'd',
          ftPlyType: '1',
          firstHtPlyType: '2',
          pointHdpPlyType: '4',
          iotPlyType: '5',
          setHandicapPlyType: '3',
          gameHdpPlyType: '6',
          firstSetPlyType: '7',
          secondSetPlyType: '8',
          thirdSetPlyType: '9',
          fourthSetPlyType: '10',
          fifthSetPlyType: '11',
          sixthSetPlyType: '12',
          oeBetType: '3',
          onex2BetType: '4',
          rhdpBetType: '8',
          rouBetType: '9',
          roeBetType: '10',        
          ronex2BetType: '11',        
          mlBetType: '12',
          rmlBetType: '13',
          style:{
            "style1" : "right",
            "style2" : "none"   
          },
          allBetToggle: true,
          showDetails: false,
          htPlyType: '2',
          showHdp: false,
          showOu: false,
          showft: false,
          showht: false,
          selectedPty: '',
          curEveId: '',
          isOpenSubMenu: {},
          isRB: false,
          data:null,
  
          items:[], 
          isLoading: true,
          startIndex: 0,
          isScrollUp: false,
          // currentMarket: '',
          // endIndex: 0,
          showCollapse: false,
          myTimeout :'',
          // marginPX : 1,
          gameBanner: window._gameBanner,
          updateScroll: true,
          loadingImg: true,
          selectedTtlArr: [],
          // isInitialize: false,
          // resultLength: 0,
          selectedKey: '',
        }
      },
      methods: {
        getData () {
          var vue = this
          // this.resultLength = 0
          // this.marginPX=1
          // if(this.int_marketToggle=="2"){
          //       this.marginPX='1.35'
          // }
          // if (!this.$el.querySelector('.scroller')) {
          //   this.isInitialize = false;
          // }
          // if(this.currentMarket==''){
          //   this.currentMarket = this.int_marketToggle
          //   this.endIndex = 0
          // }else if(this.currentMarket!='' && this.currentMarket!=this.int_marketToggle){
          //   this.currentMarket = this.int_marketToggle
          //   this.items = []
          //   this.endIndex = 0
          // }else{
          // if(this.items.length>0 && this.items.length<this.pageSize){ // check if rb match is less than pageSize (20)
          //       this.items = []
          //       // this.endIndex = 0
          //   }
          // }
          // if(this.items.length==0){
          //   for (let i = 0; i < this.sortedEvents.length; i++) {
          //     if(this.sortedEvents[i]){
          //       this.items.push(this.sortedEvents[i])
          //     }
          //   }
          //   this.isLoading = false
          //   return this.items.map((item, index) => {
          //     item.id = (index)
          //     return item
          //   }) 
          // }else{
          //   let testloop=[]
          //   for (let i = 0; i < this.sortedEvents.length; i++) {
          //     if(this.sortedEvents[i]){
          //       testloop.push(this.sortedEvents[i])
          //     }
          //   }
          //   this.isLoading = false
          //   testloop.map((item, index) => {
          //     item.id = (index)
          //     return item
          //   }) 
          //   this.items =testloop;
          // }
          let testloop=[]
          for (let i = 0; i < this.sortedEvents.length; i++) {
            if(this.sortedEvents[i]){
              testloop.push(this.sortedEvents[i])
            }
          }
          testloop.map((item, index) => {
            item.id = (index)
            return item
          }) 

          this.items = testloop;
          this.isLoading = false
        },
        getBettype(spid, rb){
          if(spid==1){
            if(rb==1){
              return this.ronex2BetType
            }else{
              return this.onex2BetType
            }
          }else{
            if(rb==1){
              return this.rmlBetType
            }else{
              return this.mlBetType
            }
          }
        },
        showHide(lid,sport){
          let vue = this
          var matche={}
          matche.sport=sport
          if(this.isHideLeague[sport]==undefined){
            this.isHideLeague[sport]=false;
          }
          if(lid==-1){
            var sprts={}
            sprts.sport=sport
            sprts.status= false
            if(this.isHideLeague[sport]==false){
                sprts.status= true
            }
            matche.lid=-1;
            this.$store.commit('IS_HIDE_LEAGUE', sprts)
            this.$store.commit('IS_COLLAPSE_MATCH',matche)
          }else{
            matche.lid=lid
            this.$store.commit('IS_COLLAPSE_MATCH',matche)
          }
          this.$store.dispatch('sortEvents')
          // this.$refs.virtualScroller.onScrollerResize()
        },
        checkLeague(lid,sport){
          if(this.isHideLeague[sport]==undefined){
            this.isHideLeague[sport]=false;
          }
          if(this.isCollapseMatch[sport]==undefined){
            this.isCollapseMatch[sport]=[];
          }
          if(this.isHideLeague[sport]==false && this.isCollapseMatch[sport].indexOf(lid)>=0){
            return true
          }else if(this.isHideLeague[sport]==true && this.isCollapseMatch[sport].indexOf(lid)<0){
            return true
          }
          return false
        },
        playtypeSelection_1(sptId){
          if(this.arr_selectedTemplate['sportId'] == 'N3' || this.arr_selectedTemplate['sportId'] == 'N21'  || this.arr_selectedTemplate['sportId'] == 'N12') {
            return this.setHandicapPlyType
          }else {
            return this.ftPlyType
          }
        },
        matchDateCheck(date){
          return moment.utc(date).utcOffset(this.$store.getters.timeZone.list[this.$store.getters.timeZone.default][1]).format("YYYY-MM-DD HH:mm:ss")
        },
        getDate(dt){
          dt = this.matchDateCheck(dt)
          if(this.cookies_lang=='zh_TW' || this.cookies_lang == 'zh_CN'){
            return new moment(dt).format("MM / DD")  
          }
          return new moment(dt).format("DD / MM")
        },
        getTime(dt){
          dt = this.matchDateCheck(dt)
          return new moment(dt).format("HH:mm")
        },
        initComponent(){
            EventBus.$emit('changeMarketTab', 1, this.$store.getters.selected_date)
            // EventBus.$emit('getMatchDetail', this.$store.getters.int_marketToggle)
            EventBus.$emit('resetTimer')
        },
        reloadSSCSportTable(){
          if(this.$store.getters.arr_selectedTemplate.marketKey==1){
            this.$store.dispatch('getTodayRBSportOdds', {
                loading: 1,
                token: token.arr_2,
                isGameBanner: 0,
                state: (this.$store.getters.selectedState)?this.$store.getters.selectedState:'',
            })
          } else {
            this.$store.dispatch('getSportOdds', {
                loading: 1,
                token: token.arr_2,
                isGameBanner: 0,
                state: (this.$store.getters.selectedState)?this.$store.getters.selectedState:'',
            })
          }
          
          let VUE=this
          _.forEach(VUE.isOpenSubMenu, function(title, tkey){
            if(VUE.isOpenSubMenu[tkey]){
                // $('.cs_'+tkey+'.tab-item-h').addClass('collapsed')
                // $('.cs'+tkey+'.transition-w-odd').addClass('expanded')
                // $('.cs'+tkey).addClass('bodan_wanfa')
                // $('.div_cs_'+tkey+'.row.justify-between').css('display','block')
                // $('.icon_'+tkey).css('display', 'none')
                // $('.iconup_'+tkey).css('display', 'block')
                // $('.iconup_'+tkey).addClass('collapsed')

                // $('.'+tkey+'_cs_extend.box_innbet_btn').css('display','grid')
            }
          })
        },
        getAllBet(event,channel=0){
          if(channel == 1 && event.rb != 1) {
            return
          }
          this.$store.commit('SELECTED_TEMPLATE', {templateId:6})
          this.$store.commit('IS_RESULT_SCHEDULE', true)
          this.$store.commit('ALLBETEVENT', null)  
          this.$store.commit('FULL_LOAD', true)
          this.$store.dispatch('getSportAllBet', {
            startTv: channel,
            event: event,
            token: token.arr_8,
          })
        },
        backToTop(){
          let vue = this
          $("html, body").animate({ scrollTop: 0 }, 1);
          $(".vue-recycle-scroller").animate({ scrollTop: 0 }, 100);
        },
        showHide_result(lid){
          if(lid==0){
              if(!$("#llge"+lid).hasClass("hidelg")){
                  $("#llge"+lid).addClass("hidelg")
                  $('#spt'+this.$store.getters.resultSport).addClass('collapsed')
                  $(".league match-indent").addClass("hidelg")
                  $(".match-odds-container").hide()
                  $(".league-title-text .league-collapse-dir").show()
                  $(".llgeAll").hide()
              }else{
                  $("#llge"+lid).removeClass("hidelg")
                  $('#spt'+this.$store.getters.resultSport).removeClass('collapsed')
                  $(".league match-indent").removeClass("hidelg")
                  $(".match-odds-container").show()
                  $(".league-title-text .league-collapse-dir").hide()
                  $(".llgeAll").show()
              }
          }else{
              if(!$("#llge"+lid).hasClass("hidelg")){
                  $("#llge"+lid).addClass("hidelg")
                  $(".llge"+lid).hide()
                  $("#imgllge"+lid).show()
                  
              }else{
                  $("#llge"+lid).removeClass("hidelg")
                  $(".llge"+lid).show()
                  $("#imgllge"+lid).hide()
              }
          }
        },
        eventDate(date) {
            return moment(date).format('MM/DD')
        },
        eventTime(date) {
            return moment(date).format('HH:mm')
        },

        sportTemplateResult(sptId){
            this.$store.commit('RESULT_SPORT', sptId);
            this.getSportResult();
        },
        sportTemplateResultDate(dt){
            this.$store.commit('RESULT_DATE', dt);
            this.getSportResult();
        },
        getSportResult(token_val='') {
            this.$store.commit('LEAGUE_LIST',[])
            this.$store.commit('SORTEDEVENTLIST',[])
            this.$store.commit('SORTEDTODAYRBEVENTLIST',[])

            this.$store.dispatch('getSportOdds', {
                loading: 1,
                isResult: true,
                token: token.arr_2,
            })
        },
        
      },
      beforeMount(){
        
        if(account.previewFlag && this.int_marketToggle == '1' && this.arr_selectedTemplate.subTemplateId == 1) {
            this.$store.commit('SELECTED_PAYLAY_DATE', 0)
        }
        
        this.initComponent()
        EventBus.$on('refreshSSCSportTable', (() => {
          this.reloadSSCSportTable()
        }).bind(this))
  
        EventBus.$off('reloadSimpleSoccerComputed')
        EventBus.$on('reloadSimpleSoccerComputed', (()=>{
          this.getData()
        }).bind(this))

        EventBus.$on('updateScroll', ((val)=>{
          this.updateScroll = val
          let vue = this
          setTimeout(function(){ 
            if(!vue.updateScroll) {
              vue.updateScroll = true
            }
          }, 5000);
        }).bind(this))

        EventBus.$off('sportTemplateResult');
        EventBus.$on('sportTemplateResult', (function(sportId){
            this.sportTemplateResult(sportId)
        }).bind(this));

        EventBus.$off('sportTemplateResultDate');
        EventBus.$on('sportTemplateResultDate', (function(dt){
            this.sportTemplateResultDate(dt)
        }).bind(this))

        EventBus.$off('getAllBet');
        EventBus.$on('getAllBet', (function(event,channel){
            this.getAllBet(event,channel)
        }).bind(this))
      },
      beforeDestroy() {
        EventBus.$off('refreshSSCSportTable')
        EventBus.$off('updateScroll')
        this.$store.commit('SC_CS_HIDE', {}) 
        this.$store.commit('IS_HIDE_LEAGUE', false)
        this.$store.commit('IS_COLLAPSE_MATCH',-1)
        $('.scroller').off('scroll')
      },
      mounted() {
        this.getData()
        $( ".list-scroll-to-top" ).hide();
        this.backToTop()
        this.isLoading = false
        this.$store.commit('IS_HIDE_LEAGUE', false)
        this.$store.commit('IS_COLLAPSE_MATCH',-1)
      },
      created() {
      },
      beforeUpdate() {
      },
    }
  </script>
  <style scoped>
  .scroller {
    height: auto;
  }
  
  .user {
    height: 32%;
  }
  </style>


// WEBPACK FOOTER //
// resources/score/vue/apps/sport/simpleSoccerTable.vue